import { CivilityLabels } from "src/constants";
import { legalFormMapping } from "src/constants/app/legalFormMapping";
import { CustomerCompany, CustomerPerson } from "src/graphql-next/generated/types";
import { CustomerFragment } from "src/graphql/generated/types";

import { validName } from "../name";

export function getCustomerDisplayName(
  customer: Pick<CustomerFragment, "firstName" | "lastName" | "civility" | "company">,
  options?: { withCivility?: boolean; nameFirst?: boolean }
): string {
  const names = options?.nameFirst
    ? [customer.lastName, customer.firstName]
    : [customer.firstName, customer.lastName];
  const data = customer.company ? [customer.company.name] : names;
  if (customer.civility && options?.withCivility && !customer.company) {
    data.unshift(CivilityLabels[customer.civility]);
  }
  if (customer.company && customer.company.legalForm) {
    data.unshift(legalFormMapping[customer.company.legalForm as keyof typeof legalFormMapping]);
  }

  return data.filter(validName).join(" ");
}

export function getCustomerDisplayNameFromGatewayNext(
  customer:
    | Pick<CustomerPerson, "__typename" | "firstName" | "lastName" | "civility">
    | Pick<CustomerCompany, "__typename" | "companyName">,
  options?: { withCivility?: boolean; nameFirst?: boolean }
): string {
  const data = [];

  if (customer.__typename === "CustomerCompany") {
    data.push(customer.companyName);
  } else {
    if (customer.civility && options?.withCivility) {
      data.push(CivilityLabels[customer.civility as keyof typeof CivilityLabels]);
    }
    const names = options?.nameFirst
      ? [customer.lastName, customer.firstName]
      : [customer.firstName, customer.lastName];
    data.push(...names);
  }

  return data.filter(validName).join(" ");
}
